import axios from 'axios'
import Vue from 'vue'
import store from '../stores/index'
const BACKEND_URL = `${process.env.BACKEND_URL}stats`

const stats = new Vue({
    beforeCreate() {
        axios.defaults.withCredentials = true
    },
    methods: {
        getAllStats(guild_id) {
            const url = BACKEND_URL + '/' + guild_id
            return axios.get(url).then(response => response.data)
        },
        getLandingStats(timestamp, guild_id) {
            const url = `${BACKEND_URL}/${guild_id}/landing${timestamp ? '?time=' + timestamp : ''}`
            return axios.get(url).then(response => response.data)
        },
    },
})

export default {
    install: function(Vue) {
        Vue.prototype.$stats = stats
    },
}



// WEBPACK FOOTER //
// ./src/api/stats.js